module.exports = __webpack_public_path__ + "static/assets/fd0765acc2eb99d7f88d1a1b236d10c2.png";